import { render, staticRenderFns } from "./ReceiptOrderQuery.vue?vue&type=template&id=64ada8c5"
import script from "./ReceiptOrderQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptOrderQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports